import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana19Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1467_37586)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M140.771 622.569L216.072 513.382L246.192 579.27L140.771 622.569Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M116.295 658.33L140.768 622.561L172.77 609.384L199.125 679.037L135.12 701.628C111.024 689.58 112.53 667.742 116.295 658.33Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M253.722 658.33L199.128 679.038L172.773 609.384L227.366 586.794L253.722 658.33Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M313.961 633.858L253.72 658.331L227.365 586.794L287.606 564.204L313.961 633.858Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M370.438 611.267L313.962 633.858L289.489 564.204L344.082 543.496L370.438 611.267Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M428.795 586.796L370.436 611.269L344.081 543.498L400.557 519.025L428.795 586.796Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M487.158 562.323L428.799 586.796L400.562 519.025L458.92 494.552L487.158 562.323Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M541.745 539.729L487.152 562.319L458.914 494.548L513.507 471.958L541.745 539.729Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M274.43 490.788L216.072 513.378L246.192 579.267L302.668 558.559L274.43 490.788Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M329.022 468.198L274.428 490.789L302.666 558.56L357.26 537.852L329.022 468.198Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M383.614 445.608L329.021 468.199L357.258 537.852L411.852 515.262L383.614 445.608Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M436.324 423.015L383.613 445.605L411.851 515.259L466.444 490.786L436.324 423.015Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M492.8 398.545L436.324 423.018L466.445 490.789L521.038 468.199L492.8 398.545Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M547.39 374.071L492.797 398.544L521.035 468.198L575.628 443.725L547.39 374.071Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M601.986 349.598L547.393 374.071L575.631 443.724L632.106 419.251L601.986 349.598Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M654.696 325.127L601.985 349.6L632.106 419.253L684.817 394.781L654.696 325.127Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M692.348 308.183L654.697 325.126L684.818 394.779L739.411 368.424C733.764 355.874 722.845 329.644 716.821 317.596C710.797 305.548 697.995 306.301 692.348 308.183Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M601.985 513.379L541.744 539.735L513.506 471.964L571.864 445.608L601.985 513.379Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M658.467 488.906L601.991 513.379L571.871 445.608L628.347 421.135L658.467 488.906Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M714.939 462.552L658.463 488.908L628.343 421.137L684.819 394.781L714.939 462.552Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M754.469 445.606L714.936 462.548L684.815 394.777L739.409 368.422L763.027 422.926C763.594 424.234 764.001 425.615 764.063 427.039C764.529 437.753 758.005 443.838 754.469 445.606Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
      <pattern id="pattern0_1467_37586" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use href="#image0_1467_37586" transform="matrix(0.0025822 0 0 0.00342331 -5.34266 -1.80418)"/>
      </pattern>
      <image id="image0_1467_37586" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};